<template>
  <div class="container">
    <h1
      class="text-white text-title mb-5 text-center"
      style="
        line-height: 100%;
        text-transform: capitalize;
        font-weight: 600;
        font-size: 48px;
      "
    >
      Layanan Aduan <span class="text-orange">Pengguna</span>
    </h1>
    <div class="card-wrapper">
      <form class="content-wrapper" @submit.prevent="submitForm">
        <div class="mb-3">
          <label for="nama">Nama</label>
          <input
            type="text"
            id="nama"
            name="nama"
            v-model="form.name"
            placeholder="Nama Lengkap Anda"
            required
          />
        </div>

        <div class="mb-3">
          <label for="email">Email</label>
          <input
            type="email"
            id="email"
            name="email"
            v-model="form.email"
            placeholder="Masukan Email"
            required
            :class="{
              'is-valid': emailValid,
              'is-invalid': form.email && !emailValid,
            }"
          />
          <small v-if="form.email && emailValid" style="color: #28a745">
            Format email valid.
          </small>
          <small v-if="form.email && !emailValid" style="color: #dc3545">
            Format email tidak valid.
          </small>
        </div>

        <div class="mb-3">
          <label for="hp">Nomor Handphone</label>
          <input
            type="text"
            id="hp"
            name="hp"
            v-model="form.phone"
            placeholder="Tulis Nomor Handphone"
            required
            @keypress="onlyNumberKey"
            @input="handlePhoneInput"
          />
          <!-- <small v-if="!form.phone.startsWith('62')" style="color: #dc3545">
            Nomor harus diawali dengan 62.
          </small> -->
        </div>

        <div class="mb-3">
          <label for="produk">Produk Terkait</label>
          <select id="produk" name="produk" v-model="form.product" required>
            <option value="" disabled selected>Pilih Produk</option>
            <option value="deposito_syariah">Deposito Syariah</option>
            <option value="tabungan_syariah">Tabungan syariah</option>
            <option value="pembiayaan_syariah">Pembiayaan Syariah</option>
            <option value="lainnya">Lainnya</option>
          </select>
        </div>

        <div class="mb-4">
          <label for="keluhan">Tulis Keluhan Anda</label>
          <textarea
            id="keluhan"
            name="keluhan"
            v-model="form.complaint_message"
            placeholder="Tulis Keluhan Anda Disini!"
            required
          ></textarea>
        </div>

        <div class="text-center">
          <button
            type="submit"
            class="btn btn-info text-white px-4"
            :disabled="loading"
          >
            {{ loading ? "Mengirim..." : "Laporkan Keluhan Anda" }}
          </button>
        </div>
      </form>
    </div>

    <!-- Modal berhasil -->
    <NewCustomModal :visible="alertPengaduan" size="medium">
      <div class="success-modal-container">
        <img
          :src="require('@/assets/images/success-icon.png')"
          alt="Berhasil"
          class="success-icon"
        />

        <div class="success-text">
          <span class="success-title">Pengaduan Berhasil</span>
          <span class="success-subtitle">Dikirim!</span>
        </div>

        <div class="success-message-box">
          <span class="text-value">{{ messageWrong }}</span>
        </div>

        <div class="modal-action-buttons success-modal">
          <button
            class="custom-btn btn-close"
            @click="closeModalProperly"
            :disabled="loading"
          >
            Tutup
          </button>
        </div>
      </div>
    </NewCustomModal>

    <!-- Modal error -->
    <NewCustomModal :visible="alertPengaduanError" size="medium">
      <div class="error-modal-container">
        <img
          :src="require('@/assets/images/wrong-icon.png')"
          alt="Gagal"
          class="error-icon"
        />

        <div class="error-text">
          <span class="error-title">Pengaduan Gagal</span>
          <span class="error-subtitle">Dikirim!</span>
        </div>

        <div class="error-message-box">
          <span class="text-value">{{ messageError }}</span>
        </div>

        <div class="modal-action-buttons error-modal">
          <button
            class="custom-btn btn-close"
            @click="closeModalProperly"
            :disabled="loading"
          >
            Tutup
          </button>
        </div>
      </div>
    </NewCustomModal>
  </div>
</template>

<script>
import pengaduan from "../../api/pengaduan";
import NewCustomModal from "../newCustomModal.vue";

export default {
  data() {
    return {
      alertPengaduan: false,
      alertPengaduanError: false,

      message: null,
      messageError: null,

      form: {
        name: "",
        email: "",
        phone: "",
        product: "",
        complaint_message: "",
      },
      loading: false,
    };
  },

  components: {
    NewCustomModal,
  },

  methods: {
    async submitForm() {
      this.loading = true;
      try {
        const response = await pengaduan.store(this.form);
        if (response.data.meta.code === 200) {
          this.alertPengaduan = true;
          this.message = response.data.meta.message;
        } else {
          this.alertPengaduanError = true;
          this.messageError = response.data.meta.message;
        }
        // Reset form
        this.form = {
          name: "",
          email: "",
          phone: "",
          product: "",
          complaint_message: "",
        };
      } catch (error) {
        console.error("Gagal mengirim keluhan:", error);
        this.alertPengaduanError = true;
        this.messageError = response.meta.message;
      } finally {
        this.loading = false;
      }
    },

    closeModalProperly() {
      this.alertPengaduan = false;
      this.alertPengaduanError = false;
    },

    onlyNumberKey(event) {
      const charCode = event.which ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        event.preventDefault();
      }
    },

    handlePhoneInput() {
      let value = (this.form.phone || "").replace(/\D/g, "");
      if (value.startsWith("0")) {
        value = "62" + value.replace(/^0+/, "");
      } else if (value && !value.startsWith("62")) {
        value = "62" + value;
      }
      this.form.phone = value;
    },
  },

  computed: {
    emailValid() {
      const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return pattern.test(this.form.email);
    },
  },
};
</script>

<style scoped>
.container {
  max-width: 90%;
}

.image-wrapper {
  display: flex;
  justify-content: center;
}

.card-wrapper {
  background-color: #ffffff;
  border-radius: 18px;
  padding: 24px;
}

@media (min-width: 1025px) {
  .card-wrapper {
    background-color: #ffffff;
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-template-rows: repeat(10, 1fr);
    gap: 0px;
    border-radius: 18px;
    padding: 0;
  }

  .content-wrapper {
    grid-column: span 10 / span 10;
    grid-row: span 8 / span 8;
    grid-column-start: 2;
    grid-row-start: 2;
  }

  .text-orange {
    color: #f7bd3a;
    font-weight: 600;
  }

  .text-white {
    color: white;
  }

  .text-title {
    margin-bottom: 0;
  }

  .text-sub-title {
    margin-bottom: 0;
    font-size: 20px;
  }

  .text-description {
    color: #b3b3b3;
    text-align: justify;
  }
}

label {
  display: block;
  font-weight: 700;
  color: #1f3a70;
  margin-bottom: 6px;
  font-size: 14px;
}
input[type="text"],
input[type="email"],
select,
textarea {
  width: 100%;
  padding: 12px 15px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 14px;
  background-color: #ffffff;
  box-sizing: border-box;
  resize: vertical;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}
input:focus,
select:focus,
textarea:focus {
  outline: none;
  border-color: #0094cc;
  box-shadow: 0 0 0 3px rgba(0, 148, 204, 0.1);
}
input::placeholder,
textarea::placeholder {
  color: #888;
}
select {
  background-color: #ffffff;
}
textarea {
  height: 120px;
}

button {
  margin-top: 15px;
  background-color: #0094cc;
  border: none;
  padding: 12px 25px;
  color: white;
  font-weight: 600;
  font-size: 14px;
  border-radius: 8px;
  cursor: pointer;
}
button:hover {
  background-color: #007aaf;
}

.is-valid {
  border: 2px solid #28a745; /* hijau */
}

.is-invalid {
  border: 2px solid #dc3545; /* merah */
}

.success-modal-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 20px;
}

.success-icon {
  width: 200px;
}

.success-text {
  margin-top: 20px;
  margin-bottom: 30px;
}

.success-title {
  display: block;
  font-weight: 700;
  font-size: 28px;
  color: green;
  line-height: 1.2;
}

.success-subtitle {
  display: block;
  font-weight: 700;
  font-size: 24px;
  color: green;
  margin-top: 5px;
}

.success-message-box {
  background-color: #f2f2f2;
  padding: 20px;
  border-radius: 10px;
  width: 100%;
  max-width: 500px;
  margin-bottom: 25px;
  color: green;
  font-weight: 500;
}

.modal-action-buttons.success-modal {
  display: flex;
  justify-content: center;
  width: 100%;
}

.custom-btn.btn-close {
  background-color: #0094cc;
  border: none;
  padding: 10px 25px;
  color: white;
  font-weight: bold;
  font-size: 14px;
  border-radius: 8px;
  cursor: pointer;
}

.custom-btn.btn-close:hover {
  background-color: #007aac;
}

.error-modal-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 20px;
}

.error-icon {
  width: 200px;
}

.error-text {
  margin-top: 20px;
  margin-bottom: 30px;
}

.error-title {
  display: block;
  font-weight: 700;
  font-size: 28px;
  color: #dc3545; /* merah */
  line-height: 1.2;
}

.error-subtitle {
  display: block;
  font-weight: 700;
  font-size: 24px;
  color: #dc3545;
  margin-top: 5px;
}

.error-message-box {
  background-color: #f8d7da; /* latar merah muda */
  padding: 20px;
  border-radius: 10px;
  width: 100%;
  max-width: 500px;
  margin-bottom: 25px;
  color: #721c24; /* teks merah tua */
  font-weight: 500;
}

.modal-action-buttons.error-modal {
  display: flex;
  justify-content: center;
  width: 100%;
}

.custom-btn.btn-close {
  background-color: #0094cc;
  border: none;
  padding: 10px 25px;
  color: white;
  font-weight: bold;
  font-size: 14px;
  border-radius: 8px;
  cursor: pointer;
}

.custom-btn.btn-close:hover {
  background-color: #007aac;
}
</style>



// WEBPACK FOOTER //
// src/components/landing-page/cardPengaduan.vue